import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isUndefined} from 'lodash'
import InputMask from "react-input-mask";
import {useSelector} from 'react-redux'
import {IconButton, Box,Tooltip,Grid } from '@material-ui/core'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
//
import ChoosePageEsignering from "../../SkapaMote/Inputs/ChoosePageEsignering"; 
import ChooseXplaceringEsignering from "../../SkapaMote/Inputs/ChooseXplaceringEsignering"; 
import ChooseYplaceringEsignering from "../../SkapaMote/Inputs/ChooseYplaceringEsignering"; 
import IntlMessages from 'util/IntlMessages';


function PersonNrInput(props) {
    const [PersonalNr,setPersonalNr] = React.useState(props.PersonalNr)
    const Flags = useSelector(state=>state.accountsData.Flags)
    const authUser = useSelector(state => state.auth.authUser)

    React.useEffect(()=>{
      setPersonalNr(props.PersonalNr)
    },[props.PersonalNr])

    // if(authUser.user_Afid === 1001) {
      /*PersonalNr:{
        Value:"",
        FilledBy:false,
        Page:1,
        Xrel:0.1,
        Yrel:0.1
    },*/
    const setPageEsignering=(Page)=>{
      props.onchangeHanelEvent("PersonalNr",{
        ...PersonalNr,
        Page:Page
      })
    }
    const setXrelEsignering=(Xrel)=>{
      props.onchangeHanelEvent("PersonalNr",{
        ...PersonalNr,
        Xrel:Xrel
      })
    }
    const setYrelEsignering=(Yrel)=>{
      props.onchangeHanelEvent("PersonalNr",{
        ...PersonalNr,
        Yrel:Yrel
      })
    }
      return (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box p={0} display="flex">
            <Box>
            <Tooltip title={<IntlMessages id="E-singing.PersonalNr.hide"/>}>
            <IconButton aria-label="delete" color={"primary"}
            onClick={(e)=>{
              props.onchangeHanelEvent("PersonalNr",{
                ...PersonalNr,
                HidePerson:!PersonalNr.HidePerson
              })
            }}
            >
            {
              props.PersonalNr.HidePerson === false?
              <RadioButtonUncheckedIcon fontSize="small" />
              :
              <RadioButtonCheckedIcon fontSize="small" />
            }
            </IconButton></Tooltip>
            </Box>
            <Box flexGrow={1} style={{margin: "auto"}}>
            <InputMask
          mask={Flags.BolagData === "NO"?"9999999999999":"999999999999"}
          alwaysShowMask={true}
          value={PersonalNr.Value}
          defaultValue={props.PersonalNr.Value}
          disabled={PersonalNr.FilledBy || PersonalNr.HidePerson}
          maskChar=""
          onChange={(event) => {
            setPersonalNr({
              ...PersonalNr,
              Value:event.target.value
            })
          }}
          onBlur={(event) => {
            props.onchangeHanelEvent("PersonalNr",{
              ...PersonalNr,
              Value:String(event.target.value).replace(/\s/g, '')
            })
          }}
        >
        { () => <TextField
          size="small"
          disabled={PersonalNr.FilledBy || PersonalNr.HidePerson}
          label={<IntlMessages id="userProfile.identityNr"/>}
          variant="outlined"
        />}
        </InputMask>

            </Box>
            
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={0} display="flex">
            <Box flexGrow={1} style={{margin: "auto"}}><IntlMessages id="E-singing.PersonalNr.Freeinputs"/></Box>
            <Box>
            <IconButton aria-label="delete" color={"primary"}
            onClick={(e)=>{
              props.onchangeHanelEvent("PersonalNr",{
                ...PersonalNr,
                FilledBy:!PersonalNr.FilledBy
              })
            }}
            >
            {
              props.PersonalNr.FilledBy === false?
              <RadioButtonUncheckedIcon fontSize="small" />
              :
              <RadioButtonCheckedIcon fontSize="small" />
            }
            </IconButton>
            </Box>
            </Box>
          </Grid>
        </Grid>
        {/*
        <Box p={0} display="flex">
        <Box flexGrow={1}>
       
        </Box>
        <Box>





        <Tooltip title="Fält för mottagaren" placement="top">
          
          </Tooltip>
        </Box>
        </Box>
        {
          props.PersonalNr.FilledBy === true?
          <Grid container spacing={1}>
            <Grid item md={12}>
            <ChoosePageEsignering
              EsigneringPage={props.PersonalNr.Page}
              setPageEsignering={setPageEsignering}
            />
            </Grid>
            <Grid item md={6}>
            <ChooseXplaceringEsignering
              EsigneringXrel={props.PersonalNr.Xrel}
              setXrelEsignering={setXrelEsignering}
            />
            </Grid>
            <Grid item md={6}>
            <ChooseYplaceringEsignering
              EsigneringYrel={props.PersonalNr.Yrel}
              setYrelEsignering={setYrelEsignering}
            />
            </Grid>
          </Grid>
          :""
        }
       */}
        </>
      )
   
}

export default PersonNrInput;